// extracted by mini-css-extract-plugin
module.exports = {"container":"_1_donationWay_container_10ZZk","other":"_1_donationWay_other_2HoeT","text":"_1_donationWay_text_19vFf"};